import { HTTP_GET, HTTP_POST, WebApiRequest } from "tools/webservice";

export const getAllPcrComments = (controlNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/homeowner/appraisal-survey/pcr-commentary/${controlNumber}`,
  successCallback,
  mountedRef,
});
export const setAllPcrComments = (controlNumber, payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/homeowner/appraisal-survey/pcr-commentary/${controlNumber}`,
  payload,
  successCallback,
  mountedRef,
});
export const getPcrCommentById = (controlNumber, payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/homeowner/appraisal-survey/pcr-commentary/${controlNumber}/get-id`,
  payload,
  successCallback,
  mountedRef,
});
export const setPcrCommentById = (controlNumber, payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/homeowner/appraisal-survey/pcr-commentary/${controlNumber}/set-id`,
  payload,
  successCallback,
  mountedRef,
});
export const removePcrCommentById = (controlNumber, payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/homeowner/appraisal-survey/pcr-commentary/${controlNumber}/remove-id`,
  payload,
  successCallback,
  mountedRef,
});

